import { render } from "./AnnotationsInspectorView.vue?vue&type=template&id=3487198e"
import script from "./AnnotationsInspectorView.vue?vue&type=script&lang=js"
export * from "./AnnotationsInspectorView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__